export default __webpack_public_path__ + "static/char-s-41-zh-Hans-5c56f43707c8ee33f8e0c023782cac37.png";